<template>
  <div class="wechat-float" v-if="visible">
    <button type="button" class="wechat-fab" aria-label="客服微信" @click="openQr">
      <svg class="wechat-fab-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M9.5 4C5.36 4 2 6.85 2 10.33c0 1.98 1.18 3.74 3.02 4.88l-.76 2.28 2.65-1.33c.78.22 1.61.34 2.47.34.27 0 .53-.02.8-.04A5.3 5.3 0 0 1 9.7 15.1c0-3.2 3.05-5.8 6.8-5.8.14 0 .28 0 .42.01C16.27 6.2 13.18 4 9.5 4zm-2.1 3.4a1.05 1.05 0 1 1 0 2.1 1.05 1.05 0 0 1 0-2.1zm4.3 0a1.05 1.05 0 1 1 0 2.1 1.05 1.05 0 0 1 0-2.1z"/>
        <path fill="currentColor" d="M16.5 10.3c-3.2 0-5.8 2.18-5.8 4.86 0 2.68 2.6 4.86 5.8 4.86.62 0 1.22-.08 1.78-.24l2.04 1.02-.54-1.62c1.32-.9 2.16-2.22 2.16-3.72 0-2.68-2.6-4.86-5.8-4.86zm-1.55 3.55a.8.8 0 1 1 0 1.6.8.8 0 0 1 0-1.6zm3.15 0a.8.8 0 1 1 0 1.6.8.8 0 0 1 0-1.6z"/>
      </svg>
      <span class="wechat-fab-text">客服</span>
    </button>

    <transition name="qr-overlay">
      <div v-if="qrVisible" class="qr-overlay" @click.self="closeQr">
        <div class="qr-modal" @click.stop>
          <img :src="wechatQr" alt="客服微信二维码" class="qr-modal-img" />
          <p class="qr-modal-tip">添加客服微信</p>
          <button type="button" class="qr-close" aria-label="关闭" @click="closeQr">
            <i class="el-icon-close"></i>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import wechatQr from '@/assets/images/wechat-qr.png'

export default {
  name: 'WechatFloat',
  data() {
    return {
      wechatQr,
      qrVisible: false
    }
  },
  computed: {
    visible() {
      const path = this.$route.path
      const name = this.$route.name
      return !path.startsWith('/admin') && name !== 'Login' && name !== 'Register'
    }
  },
  methods: {
    openQr() {
      this.qrVisible = true
    },
    closeQr() {
      this.qrVisible = false
    }
  }
}
</script>

<style scoped>
.wechat-fab {
  position: fixed;
  right: 20px;
  bottom: 88px;
  z-index: 3200;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 56px;
  height: 56px;
  border: none;
  border-radius: 50%;
  background: #07c160;
  color: #fff;
  box-shadow: 0 8px 20px rgba(7, 193, 96, 0.38);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.wechat-fab:hover {
  transform: translateY(-2px) scale(1.04);
  box-shadow: 0 10px 24px rgba(7, 193, 96, 0.48);
}

.wechat-fab-icon {
  width: 26px;
  height: 26px;
}

.wechat-fab-text {
  font-size: 10px;
  line-height: 1;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.qr-overlay-enter-active,
.qr-overlay-leave-active {
  transition: opacity 0.22s ease;
}

.qr-overlay-enter,
.qr-overlay-leave-to {
  opacity: 0;
}

.qr-overlay {
  position: fixed;
  inset: 0;
  z-index: 3300;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.45);
  pointer-events: auto;
}

.qr-modal {
  position: relative;
  z-index: 3301;
  padding: 24px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.qr-modal-img {
  display: block;
  width: 240px;
  height: 240px;
  object-fit: cover;
  border-radius: 12px;
}

.qr-modal-tip {
  margin: 14px 0 0;
  font-size: 15px;
  color: #374151;
  font-weight: 500;
}

.qr-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: #f3f4f6;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.qr-close:hover {
  background: #e5e7eb;
  color: #374151;
}

@media (max-width: 768px) {
  .wechat-fab {
    right: 14px;
    bottom: 72px;
    width: 50px;
    height: 50px;
  }

  .qr-modal-img {
    width: 200px;
    height: 200px;
  }
}
</style>
